var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3854 12.4456C8.73512 14.5683 4.85569 14.4012 2.3989 11.9444C-0.237135 9.30838 -0.237135 5.03452 2.3989 2.39848C5.03494 -0.237562 9.30881 -0.237562 11.9448 2.39848C14.4016 4.85526 14.5687 8.73468 12.446 11.385L17.6017 16.5406C17.8946 16.8335 17.8946 17.3084 17.6017 17.6012C17.3088 17.8941 16.8339 17.8941 16.541 17.6012L11.3854 12.4456ZM3.45956 10.8838C1.40931 8.83351 1.40931 5.50939 3.45956 3.45914C5.50982 1.40888 8.83393 1.40888 10.8842 3.45914C12.9329 5.50788 12.9344 8.82863 10.8887 10.8792C10.8872 10.8807 10.8857 10.8822 10.8842 10.8837C10.8827 10.8852 10.8812 10.8867 10.8797 10.8883C8.82906 12.934 5.50831 12.9325 3.45956 10.8838Z",
    fill: "#DFFE02"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.7daf3d070ec3e6a02ee0de8ebe2ca683.svg";
export { ForwardRef as ReactComponent };